<template>
  <component
    :is="isBlocked ? 'div' : 'router-link'"
    class="home-module-card text-decoration-none"
    :to="{ name: 'module', params }"
  >
    <div
      class="module-card-wrapper"
      :class="{ blocked: isBlocked }"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div class="module-card" :style="style">
        <div v-if="isBlocked" class="blocked-wrapper">
          <span>Módulo bloqueado</span>
          <i class="icon-lock" />
          <span>
            Este módulo será liberado
            {{ timeToRelease }}
          </span>
        </div>
        <img
          v-if="noCoverAndNoPlaceholder"
          class="img-partner-placeholder"
          :src="$setup.partnerLogo"
        />
      </div>
    </div>
    <h5 class="module-name text-wrap pt-2">{{ module.name }}</h5>
  </component>
</template>

<script>
import { get } from "lodash";

export default {
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hover: false,
      params: {
        id: this.module.id
      }
    };
  },
  computed: {
    noCoverAndNoPlaceholder() {
      return !this.module.picture && !this.$setup.setup.placeholder_module;
    },
    style() {
      const url =
        this.module.picture || this.$setup.setup.placeholder_module || "";
      const gradient = "linear-gradient(0deg, #0c0d1395 0%, #0c0d1300 80%)";

      if (this.hover && !this.isBlocked) {
        return `
          background-image: url(${url});
        `;
      }

      if (url && url.length) {
        return `
            background-image: ${gradient}, url(${url});
          `;
      }

      return "";
    },
    submodules() {
      return this.module.sub_modules.filter(sub => sub.status === "published")
        .length;
    },
    lessons() {
      return this.module.lessons.filter(lesson => lesson.status === "published")
        .length;
    },
    isBlocked() {
      return get(this.module, "is_blocked.status");
    },
    timeToRelease() {
      if ("days_left_to_release" in this.module.is_blocked) {
        return this.module.is_blocked.days_left_to_release == 0
          ? "amanhã"
          : `em ${this.module.is_blocked.days_left_to_release + 1} dias`;
      }
      return "em breve";
    }
  }
};
</script>

<style lang="scss" scoped>
.home-module-card {
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  .module-card-wrapper {
    padding: 0;
    border-radius: 6px;
    transition: border 0.1s ease-in-out, padding 0.1s ease-in-out;

    @media screen and (max-width: 400px) {
      width: 200px;
    }

    .icon-lock {
      font-size: 30px;
    }

    .module-card {
      aspect-ratio: 200/290;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      height: 100%;
      width: 100%;
      border-radius: 6px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .img-partner-placeholder {
        max-height: 48px;
        max-width: 48px;
        min-height: 48px;
        min-width: 48px;
      }
    }

    .blocked-wrapper {
      background: rgba(50, 28, 61, 0.8);
      border-radius: 6px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      gap: 16px;
      font-weight: 500;
      color: #bebfc7;
      padding: 0px 12px;
      display: flex;
      text-align: center;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      i {
        color: #ffffffcc;
        font-size: 32px;
        @media screen and (max-width: 768px) {
          font-size: 28px;
        }
        @media screen and (max-width: 540px) {
          font-size: 20px;
        }
      }
    }

    &:not(.blocked):hover {
      border: 2px solid #3e56ac !important;
      padding: 2.5px;
      .module-card {
        border-radius: 4px;
      }
    }
  }
  .module-name {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    @media screen and (max-width: 768px) {
      font-size: 12px !important;
    }
  }
}
</style>
